import { useTranslation } from '@web_opxp/features';
import { TInvoiceChannel } from '../types';

interface IInvoiceLinkProps {
  channel?: TInvoiceChannel;
  invoiceUrl: string;
}

export default function InvoiceLink({ channel, invoiceUrl }: Readonly<IInvoiceLinkProps>) {
  const { t } = useTranslation();
  if (!channel || channel === 'web') {
    if (!invoiceUrl) {
      return null;
    }
    return (
      <a href={invoiceUrl} target="_blank" rel="noopener noreferrer">
        {t('manage:Orders.format')}
      </a>
    );
  }
  return (
    <span>
      {t(channel === 'app_store' ? 'manage:Orders.MobileInvoice.Apple' : 'manage:Orders.MobileInvoice.Google')}
    </span>
  );
}
